import type { PropsWithChildren, FunctionComponent } from 'react'
import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { type RetailerScopedRouteParams } from '../../../../legacy/common/types'
import { type DashRouteComponentProps } from '../../../../legacy/dash-components/dash-route/utils/dashRoute.types'
import WarehouseProvider from '../../../../utils/contexts/warehouse/WarehouseProvider'
import { reportBootTiming } from '../../../../utils/performance/bootTiming'
import { AttachRetailerAnalyticsMetadata } from '../../../utils/AttachAnalyticsMetadata'
import { RetailerScopedRoutes } from './RetailerScopedRoutes'

interface Props extends DashRouteComponentProps<RetailerScopedRouteParams> {}

export const RetailerScopedSection: FunctionComponent<PropsWithChildren<Props>> = ({
  match: {
    params: { warehouse_id: warehouseId },
  },
}) => {
  const history = useHistory()

  // Track framework boot time when retailer-scoped section is ready
  useEffect(() => {
    reportBootTiming('framework_boot_time_retailer_scoped_v2')
  }, [])

  if (warehouseId === 'undefined') {
    history.replace(location.pathname.replace(/\/warehouses\/(undefined)/, '/warehouses/0'))
  }

  return (
    <>
      <WarehouseProvider ids={warehouseId === 'undefined' ? '0' : warehouseId}>
        <AttachRetailerAnalyticsMetadata />
        <RetailerScopedRoutes />
      </WarehouseProvider>
    </>
  )
}
